import { render, staticRenderFns } from "./DataTableCategories.vue?vue&type=template&id=115cc436&"
import script from "./DataTableCategories.vue?vue&type=script&lang=js&"
export * from "./DataTableCategories.vue?vue&type=script&lang=js&"
import style0 from "./DataTableCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports